import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherNewItem_EditPage_Query = graphql(`
	query VoucherNewItem_EditPage($hotelID: ID!, $duplicateVoucherID: ID) {
		voucherNewItem(hotelID: $hotelID, duplicateVoucherID: $duplicateVoucherID) {
			id
			hotelID
			voucherID
			inSale
			name
			description
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			voucherPrice {
				currencyType
				amount
			}
			sellingPrice {
				currencyType
				amount
			}
			saleTypeForTerm
			saleStart
			saleEnd
			maxStockNum
			soldNumTotal
			voucherLimitType
			intervalPrepDates
			cinStart
			cinEnd
			deletedAt
		}
	}
`);
